"use client";

import { LegalShell } from "@/components/legal/legal-shell";

export function TermConditionPage() {
  return (
    <LegalShell title="Syarat dan ketentuan GASS" updated="Pembaruan terakhir: 30/10/2023">

      <section>
        <h2>1. Pendahuluan</h2>
        <ul>
          <li>
            <p>
              Selamat Datang di Gass.co.id! Gass.co.id(<b>“Situs”</b> atau{" "}
              <b>“Platform”</b> atau <b>“Aplikasi”</b>) merupakan layanan yang
              disediakan oleh PT Gass.co.id Karsa Wesya (<b>“Gass.co.id”</b>{" "}
              atau <b>“Kami”</b> atau <b>“Penyedia Platform”</b>) sebuah
              perusahaan yang didirikan berdasarkan hukum Negara Republik
              Indonesia yang kantor dan domisili usahanya di Jakarta, Indonesia.
              Situs Gass.co.id adalah <b>“Layanan”</b> sebagaimana yang
              dijelaskan dalam Syarat dan Ketentuan ini (<b>“S&amp;K”</b>). Jika ada
              perbedaan antara S&amp;K dan/atau Kebijakan Privasi, maka S&amp;K yang
              akan berlaku.
            </p>
          </li>
          <li>
            <p>
              Pengunjung maupun Pengguna (<b>“Anda”</b>) harus membaca dan
              memeriksa Kebijakan Privasi pada{" "}
              <a href="https://gass.co.id/privacy" target="_blank" rel="noopener noreferrer">
                https://gass.co.id/privacy
              </a>{" "}
              serta S&amp;K di bawah ini karena akan berdampak pada hak dan
              kewajiban Anda sebagai pengunjung maupun pengguna Situs. Dengan
              melanjutkan kunjungan dan/atau penggunaan Situs Gass.co.id, Anda
              menyatakan persetujuan anda untuk dan secara hukum menerima,
              tunduk dan terikat pada S&amp;K ini.
            </p>
          </li>
          <li>
            <p>
              Penggunaan Anda atas Situs Gass.co.id dan fitur-fiturnya (termasuk
              Gass.co.id Page, Gass.co.id Store, Gass.co.id Wholesale,
              Gass.co.id Menu, Gass.co.id Omni, dan Gass.co.id Market), konten
              atau layanan (untuk selanjutnya disebut sebagai <b>“Konten”</b>)
              yang tersedia pada Situs ini, tunduk pada S&amp;K yang berlaku.
            </p>
          </li>
          <li>
            <p>
              Kami akan memberi Anda pemberitahuan 14 hari kerja sebelumnya
              sebelum ada revisi terhadap S&amp;K ini, sebagai bentuk permintaan
              persetujuan Anda melalui pengumuman pada email atau tautan
              elektronik. Penggunaan Layanan berkelanjutan oleh Anda setelah
              menerima pemberitahuan akan perubahan tersebut juga dapat dianggap
              sebagai penerimaan Anda terhadap S&amp;K yang telah direvisi tersebut.
              Jika Anda tidak menyetujui S&amp;K yang diubah, Anda dapat berhenti
              mengakses dan menggunakan Layanan Gass.co.id dengan ketentuan
              sebagaimana ditentukan dalam bagian 18 tentang Pembatalan dan
              Pengakhiran Layanan pada S&amp;K Gass.co.id ini.
            </p>
          </li>
          <li>
            <p>
              Setiap kegiatan terkait dengan penggunaan Situs, dilindungi secara
              hukum melalui Undang-Undang Republik Indonesia No.11 Tahun 2008
              tentang Informasi dan Transaksi Elektronik sebagaimana telah
              diubah dengan Undang-Undang Nomor 19 Tahun 2016 tentang Perubahan
              Atas Undang-Undang Nomor 11 Tahun 2008 tentang Informasi dan
              Transaksi Elektronik, Undang-Undang Republik Indonesia No. 28
              Tahun 2014 tentang Hak Cipta, Undang-Undang Nomor 27 Tahun 2022
              tentang Pelindungan Data Pribadi dan peraturan perundang-undangan
              lainnya yang berlaku. Segala bentuk perikatan yang timbul dari
              segala aktivitas di Situs Kami telah memenuhi kaidah dan syarat
              sahnya suatu perikatan sebagaimana yang tercantum dalam Kitab
              Undang-Undang Hukum Perdata.
            </p>
          </li>
          <li>
            <p>
              Ketentuan hukum yang ditetapkan di bawah ini, mengatur mengenai
              perjanjian pembelian atas konten apa pun dari Situs ini. Dengan
              melanjutkan penggunaan Situs maka Anda setuju dengan S&amp;K dan
              Kebijakan Privasi.
            </p>
          </li>
          <li>
            <p>
              Gass.co.id dapat meluncurkan Layanan tertentu dalam versi beta,
              yang mungkin tidak berfungsi dengan baik atau sama seperti versi
              akhir, yang mana karena sifatnya sebagai versi beta atau
              percobaan, maka penanganan dan/atau pertanggungjawaban tidak dapat
              disamakan seperti versi akhir. Gass.co.id juga dapat membatasi
              fitur tertentu atau membatasi akses Anda ke bagian atau seluruh
              Aplikasi atau Layanan atas kebijakannya sendiri dengan
              pemberitahuan 14 hari kerja sebelumnya.
            </p>
          </li>
          <li>
            <p>
              Gass.co.id berhak untuk menolak memberikan akses ke Aplikasi atau
              Layanan kepada Anda atau mengizinkan Anda untuk membuka Akun
              dengan alasan apapun. Jika Pengguna tidak menyetujui salah satu,
              sebagian, atau seluruh isi S&amp;K, maka Pengguna tidak diperkenankan
              menggunakan Layanan di Situs Gass.co.id.
            </p>
          </li>
          <li>
            <p>
              DENGAN MENGGUNAKAN LAYANAN Gass.co.id ATAU MEMBUKA AKUN, ANDA
              MEMBERIKAN PENERIMAAN DAN PERSETUJUAN SEPENUHNYAATAS S&amp;K INI,
              TERMASUK SYARAT &amp; KETENTUAN TAMBAHAN SERTA KEBIJAKAN YANG
              DISEBUTKAN DI SINI DAN/ATAU TERKAIT DI SINI. Anda dapat
              membatalkan Akun Anda atau mengakhiri S&amp;K ini dengan melihat
              ketentuan bagian 18 tentang Pembatalan dan Pengakhiran Layanan.
            </p>
          </li>
        </ul>
      </section>

      <section>
        <h2>2. Definisi</h2>
        <ul>
          <li>
            <p>
              <b>Akun</b> adalah akun Pengguna yang diperoleh setelah
              pendaftaran melalui Aplikasi atau situs yang memerlukan nama
              lengkap, alamat email dan nomor telepon seluler pribadi yang sah
              untuk mendaftar,dan terdapat verifikasi kode OTP yang akan masuk
              ke nomor seluler pribadi sehingga selanjutnya akun Pengguna dapat
              digunakan.
            </p>
          </li>
          <li>
            <p>
              <b>Gass.co.id</b> adalah sebuah perseroan terbatas bernama PT
              Gass.co.id Karsa Wesya yang didirikan berdasarkan hukum Negara
              Republik Indonesia.
            </p>
          </li>
          <li>
            <p>
              <b>Customer</b> adalah pembeli yang menggunakan Layanan
              Gass.co.id.
            </p>
          </li>
          <li>
            <p>
              <b>Konten</b> adalah segala jenis penggunaan layanan, materi
              dan/atau muatan yang dibuat dan/atau diunggah ke dalam Platform.
            </p>
          </li>
          <li>
            <p>
              <b>Layanan</b> adalah salah satu atau seluruh layanan yang
              disediakan Gass.co.id kepada Pengguna sebagaimana dimaksud dalam
              bagian 3 di bawah ini.
            </p>
          </li>
          <li>
            <p>
              <b>Merchant</b> adalah penjual yang menggunakan Layanan
              Gass.co.id.
            </p>
          </li>
          <li>
            <p>
              <b>Pengguna</b> atau Anda adalah pengguna Layanan Gass.co.id yang
              merupakan pembeli maupun penjual.
            </p>
          </li>
          <li>
            <p>
              <b>Retailer</b> adalah pihak perseorangan atau perusahaan yang
              melakukan penjualan langsung produk ke para pelanggan/customer
              langsung atau end user. Retailer dalam Layanan Gass.co.id
              Wholesale dipersamakan posisinya sebagai customer.
            </p>
          </li>
          <li>
            <p>
              <b>Situs</b> adalah{" "}
              <a href="https://gass.co.id" target="_blank" rel="noopener noreferrer">
                https://gass.co.id
              </a>{" "}
              merupakan situs resmi yang digunakan PT Gass.co.id Karsa Wesya
              dalam memberikan berbagai layanan secara digital.
            </p>
          </li>
          <li>
            <p>
              <b>S&amp;K</b> adalah dokumen ini yang merupakan Perjanjian antara
              Pengguna dan Gass.co.id yang berisikan seperangkat peraturan yang
              mengatur hak, kewajiban, tanggung jawab Pengguna dan Gass.co.id,
              serta tata cara penggunaan sistem Layanan Gass.co.id.
            </p>
          </li>
          <li>
            <p>
              <b>Supplier</b> adalah pihak perorangan atau bisnis yang memasok
              atau menyuplai produk barang atau jasa kepada bisnis lain baik itu
              pihak perseorangan atau perusahaan (Retailer). Supplier Layanan
              Gass.co.id Wholesale dipersamakan posisinya sebagai Merchant.
            </p>
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Layanan Gass.co.id</h2>
        <article>
          <p>
            Situs ini memungkinkan Pengguna untuk menggunakan Layanan dan
            melakukan hal-hal sebagai berikut:
          </p>
        </article>
        <ol>
          <li>
            <p>
              Gass.co.id Page: Platform pembuat landing page untuk
              Pengguna/Penjual (Merchant);
            </p>
          </li>
          <li>
            <p>Gass.co.id Store: Platform sistem toko online untuk Merchant;</p>
          </li>
          <li>
            <p>
              Gass.co.id Wholesale: Platform marketplace jual beli grosir online
              untuk Supplier dan Retailer.
            </p>
          </li>
          <li>
            <p>
              Gass.co.id Menu: Platform online order system untuk Merchant F&amp;B;
            </p>
          </li>
          <li>
            <p>
              Gass.co.id Omni: Platform untuk kelola pesanan dan stok dari
              marketplace untuk Merchant.
            </p>
          </li>
          <li>
            <p>
              Gass.co.id Market: Platform tools dan extensions yang tersedia
              untuk Layanan Gass.co.id yang merupakan produk layanan partner
              yang terafiliasi dengan Gass.co.id.
            </p>
          </li>
        </ol>
        <article>
          <p>
            Layanan termasuk platform online yang menyediakan tempat dan peluang
            untuk penjualan barang atau produk antara Customer dan Merchant
            sehingga setiap kontrak penjualan yang dibuat melalui Layanan ini
            adalah antara Anda sebagai Customer dan/atau Merchant secara
            langsung, dan Gass.co.id bukan merupakan pihak dalam kontrak
            tersebut. Gass.co.id dapat atau tidak dapat melakukan penyaringan
            awal terhadap Pengguna atau Konten atau informasi yang diberikan
            oleh Pengguna. Customer dapat bertransaksi dengan Merchant
            menggunakan Situs dari Gass.co.id tersebut sebagaimana yang telah
            disebutkan di atas. Kami tidak bertanggung jawab atas setiap
            tindakan dan/atau kelalaian Pengguna. Situs ini hanya merupakan
            sarana untuk memfasilitasi pengelolaan operasional dan memaksimalkan
            pelayanan. Keputusan atas setiap penggunaan Situs merupakan
            keputusan Pengguna dan segala akibat yang ditimbulkan atas keputusan
            tersebut merupakan tanggung jawab masing-masing Pengguna. Kami juga
            berhak sewaktu-waktu mengubah, menghapus, menambah atau memperbarui
            fitur atau fasilitas dalam Situs. Seluruh perubahan fitur atau
            fasilitas dalam Situs tersebut tunduk pada S&amp;K ini dan/atau hukum
            dan peraturan yang berlaku. Kami akan memberi Anda pemberitahuan 14
            hari kerja sebelumnya sebelum ada revisi terhadap S&amp;K ini.
          </p>
        </article>
      </section>

      <section>
        <h2>4. Ketentuan Umum</h2>
        <ol>
          <li>
            <p>
              Anda berjanji bahwa Anda akan menggunakan Situs hanya untuk tujuan
              penggunaan sebagaimana disebutkan pada S&amp;K. Anda berjanji tidak
              akan menyalahgunakan atau menggunakan Situs untuk tujuan penipuan,
              manipulasi atau tindakan kriminal atau tindakan-tindakan lain yang
              menyebabkan ketidaknyamanan atau kerugian terhadap orang lain.
              Gass.co.id memiliki hak penuh untuk membatalkan transaksi atau
              menon-aktifkan Akun milik Pengguna, apabila diketahui terdapat
              indikasi penyalahgunaan dan/atau penipuan atas penggunaan Akun
              pada Situs atau suatu tindakan yang mengarah pada perbuatan pidana
              dan/atau bertentangan dengan peraturan perundang-undangan yang
              berlaku.
            </p>
          </li>
          <li>
            <p>
              Anda memahami dan setuju bahwa penggunaan Situs oleh Anda akan
              tunduk pula pada Kebijakan Privasi Kami sebagaimana dapat diubah
              dari waktu ke waktu. Dengan menggunakan Situs, Anda juga
              memberikan persetujuan sebagaimana dipersyaratkan berdasarkan
              Kebijakan Privasi Kami.
            </p>
          </li>
          <li>
            <p>
              Dengan memberikan informasi kepada Kami, Anda menyatakan bahwa
              Anda memberikan hak kepada Kami atas penggunaan informasi tersebut
              sehubungan dengan penggunaan dan pengembangan Layanan pada Situs
              ini.
            </p>
            <p>Anda menyetujui untuk tidak melakukan hal-hal di bawah ini:</p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <p>
                  Menggunakan Layanan untuk menyamar sebagai orang atau entitas
                  lain, atau kalau tidak memalsukan afiliasi Anda dengan
                  seseorang atau suatu entitas;
                </p>
              </li>
              <li>
                <p>Menggunakan Layanan untuk tujuan menipu;</p>
              </li>
              <li>
                <p>
                  Melakukan tindakan yang dapat merusak sistem tanggapan
                  (feedback) Pengguna atau perangkat;
                </p>
              </li>
              <li>
                <p>
                  Menggunakan Layanan untuk sengaja atau tidak sengaja melanggar
                  hukum, aturan, kode arahan, pedoman, kebijakan atau peraturan
                  yang berlaku;
                </p>
              </li>
              <li>
                <p>
                  Setiap dan segala tindakan sehubungan dengan Layanan pada
                  Situs Gass.co.id yang dapat dianggap sebagai tindakan yang
                  melanggar hukum dan ketentuan perundangan yang berlaku di
                  Indonesia.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Dengan menjadi Pengguna Situs, Gass.co.id memiliki kewenangan dan
              hak penuh untuk menggunakan dan melakukan analisa atas data
              pribadi yang dilakukan melalui Situs. Pengguna juga menyetujui
              bahwa Gass.co.id memiliki kewenangan penuh untuk menggunakan data
              pribadi dan informasi Pengguna untuk diberikan kepada pihak ketiga
              yang bekerja sama atau ditunjuk oleh Gass.co.id.
            </p>
          </li>
        </ol>
      </section>

      <section>
        <h2>5. Ketentuan Penggunaan Situs Gass.co.id</h2>
        <ol>
          <li>
            <p>
              Akses dan Penggunaan Konten. Untuk menggunakan Situs, Anda
              memerlukan perangkat yang memenuhi persyaratan sistem dan
              kompatibilitas untuk Konten yang relevan, akses Internet yang
              berfungsi dengan baik, dan perangkat lunak yang kompatibel.
            </p>
          </li>
          <li>
            <p>
              Batasan umur. Untuk menggunakan Konten yang tersedia di Situs
              Gass.co.id, Anda harus memiliki akun yang valid yang tunduk pada
              batasan usia di negara tersebut, misalnya, jika Anda dianggap di
              bawah umur oleh Negara dan/atau pada yurisdiksi, maka Anda perlu
              memiliki izin orang tua atau wali untuk menggunakan Konten yang
              disediakan di Situs Gass.co.id dan untuk menyetujui S&amp;K ini. Anda
              harus mematuhi batasan usia tambahan yang mungkin berlaku untuk
              penggunaan Konten atau fitur tertentu di Situs Gass.co.id (jika
              ada). Wali dan anggota keluarga juga perlu memenuhi persyaratan
              tambahan ini.
            </p>
          </li>
          <li>
            <p>
              Biaya Pihak Ketiga. Anda akan bertanggung jawab atas akses data
              atau biaya apa pun yang dikeluarkan oleh pihak ketiga (seperti
              penyedia Internet atau operator seluler) sehubungan dengan
              penggunaan dan tampilan atas Konten dan Situs Gass.co.id.
            </p>
          </li>
          <li>
            <p>
              Updates. Situs Gass.co.id, tempat penyimpanan yang terkait,
              ataupun Konten mungkin perlu pembaharuan untuk versi baru,
              misalnya, untuk perbaikan bug, peningkatan fungsionalitas, plug-in
              yang hilang. (untuk selanjutnya disebut “Updates”). Updates
              tersebut mungkin Anda perlukan agar dapat menggunakan Situs
              Gass.co.id atau untuk mengakses, mengunduh, atau menggunakan
              Konten. Dengan menyetujui S&amp;K dan dengan menggunakan Situs
              Gass.co.id, Anda setuju untuk menerima Updates ini secara
              otomatis, termasuk S&amp;K yang diperbarui, yang dapat diubah dan/atau
              diperbarui dari waktu ke waktu.
            </p>
          </li>
          <li>
            <p>
              Informasi pribadi. Memberikan perlindungan pada informasi pribadi
              Anda merupakan hal yang sangat penting bagi Kami karenanya
              Kebijakan Privasi Situs Gass.co.id menjelaskan cara Kami
              menggunakan data pribadi dan melindungi privasi Anda saat
              menggunakan Situs Gass.co.id. Gass.co.id mungkin perlu memberikan
              informasi pribadi Anda, seperti nama dan alamat e-mail, kepada
              penyedia yang bertujuan untuk memproses transaksi atau menyediakan
              Konten untuk Anda. Penyedia setuju untuk menggunakan informasi ini
              sesuai dengan kebijakan privasi mereka. Dengan memberikan Kami
              informasi, Anda menyatakan bahwa Anda bersedia memberikan Kami
              informasi, untuk Kami gunakan dan bagikan kepada pihak manapun
              yang akan mendukung Layanan Kami kepada Anda.
            </p>
          </li>
          <li>
            <p>
              Cookies. Informasi tertentu juga dapat dikumpulkan secara otomatis
              dengan menggunakan cookies. Cookies adalah berkas data kecil yang
              tersimpan pada komputer atau perangkat seluler Anda. Kami
              menggunakan cookies untuk melacak aktivitas Pengguna dengan tujuan
              untuk meningkatkan interaksi antarmuka (user interface) dan
              pengalaman Pengguna dan mengingat preferensi penelusuran Anda
              dalam Situs Kami. Sebagian besar perangkat seluler dan peramban
              internet mendukung penggunaan cookies; namun Anda dapat
              menyesuaikan pengaturan pada perangkat seluler atau peramban
              internet Anda untuk menolak beberapa jenis cookies atau cookies
              spesifik tertentu.
            </p>
          </li>
          <li>
            <p>
              Akses Akun Yang Tidak Sah. Anda harus menjaga detail keamanan akun
              Anda dan tidak boleh membagikannya kepada orang lain. Anda tidak
              boleh mengumpulkan atau mengambil data pribadi siapa pun dari
              pengguna Situs Gass.co.id, termasuk pengguna nama akun lain dari
              Situs Gass.co.id. Anda hanya dapat menggunakan akun sendiri dan
              Anda berjanji untuk tidak mengizinkan orang lain, menggunakan
              identitas atau akun Anda. Anda tidak boleh mengalihkan atau
              mentransfer akun ke manapun. Anda harus menjaga setiap kata sandi
              akun dan identifikasi lain yang Kami berikan untuk Anda dengan
              aman dan rahasia. Jika ada pengungkapan kata sandi milik Anda,
              yang menyebabkan penggunaan yang tidak sah atas akun atau
              identitas Anda, setiap pengiriman dan/atau permintaan yang
              dihasilkan dari penggunaan yang tidak sah, akan tetap dianggap
              pengajuan dan/atau permintaan yang sah. Harap beri tahu Kami, jika
              Anda tidak lagi memiliki kendali atas Akun, misalnya, Akun Anda
              diretas atau perangkat Anda dicuri, sehingga Kami dapat
              membatalkan akun Anda sebagaimana mestinya. Harap dicatat bahwa
              Anda bertanggung jawab atas penggunaan Akun dan dapat dimintai
              pertanggungjawabannya meskipun Akun tersebut disalahgunakan oleh
              orang lain.
            </p>
          </li>
          <li>
            <p>
              Jika Anda terus menggunakan Gass.co.id, hal ini menunjukkan bahwa
              Anda menerima S&amp;K terbaru. S&amp;K terbaru akan berlaku untuk
              penggunaan Anda atas seluruh Konten (termasuk Konten yang telah
              Anda posting atau beli di masa lalu) dan setiap instalasi atau
              pembelian berikutnya. Jika Anda tidak setuju dengan perubahan ini,
              Anda akan diberi kesempatan untuk mengunduh Konten yang dibeli
              sebelumnya atau di-install dan berhenti menggunakan Situs
              Gass.co.id. Anda dapat terus melihat salinan Konten di Perangkat
              Anda sesuai dengan dari Persyaratan yang disetujui pada versi
              terakhir.
            </p>
          </li>
          <li>
            <p>
              Validitas Konten Situs. Kami akan mengambil seluruh langkah wajar
              untuk memastikan bahwa informasi di Situs ini benar. Namun, Kami
              tidak menjamin kebenaran atau kelengkapan materi di Situs ini.
              Kami dapat membuat perubahan materi di Situs ini kapan saja dan
              tanpa pemberitahuan.
            </p>
          </li>
        </ol>
      </section>

      <section>
        <h2>6. Pendaftaran dan Pengaksesan Akun Gass.co.id</h2>
        <ol>
          <li>
            <p>
              Anda dapat menggunakan fitur pada Situs secara lengkap jika Anda
              telah mendaftarkan diri. Setelah Anda berhasil mendaftarkan diri,
              maka Kami akan memberikan Anda Akun pribadi yang dapat diakses
              dengan kata sandi yang Anda pilih.
            </p>
          </li>
          <li>
            <p>
              Kami berhak meminta, mengumpulkan dan memproses informasi pribadi
              Anda, seperti nama lengkap, alamat surat elektronik (surel/email),
              dan nomor telepon seluler Anda ketika Anda mendaftar. Anda harus
              memberikan informasi yang akurat dan lengkap, memperbaharui
              informasi dan setuju untuk memberikan kepada kami bukti identitas
              apapun yang secara wajar dapat Kami mintakan. Jika informasi
              pribadi yang diberikan kepada Kami ada yang berubah, misalnya,
              jika Anda mengubah alamat surel, nomor telepon, atau jika Anda
              ingin membatalkan akun Anda, mohon perbaharui rincian informasi
              Anda dengan mengirimkan permintaan Anda kepada Kami. Kami akan,
              sedapatnya, memberlakukan perubahan yang diminta tersebut dalam
              waktu 30 (tiga puluh) hari kerja sejak diterimanya pemberitahuan
              perubahan.
            </p>
          </li>
          <li>
            <p>
              Setelah melakukan pendaftaran, sistem Kami akan mengirimkan kode
              verifikasi secara otomatis dan mengirim kode verifikasi tersebut
              melalui pesan singkat SMS atau WhatsApp dari nomor telepon yang
              Anda berikan. Anda perlu melakukan verifikasi dengan memasukan
              kode tersebut pada halaman pendaftaran.
            </p>
          </li>
          <li>
            <p>
              Setelah melakukan verifikasi, sistem Kami akan membuatkan akun
              pribadi. Nomor telepon yang Anda gunakan akan melekat pada akun
              Anda sehingga tidak bisa membuat Akun baru dengan nomor telepon
              yang sudah didaftarkan. Hal yang sama juga berlaku apabila Anda
              mengubah nomor telepon di kemudian hari.
            </p>
          </li>
          <li>
            <p>
              Apabila Anda keluar dari Akun Anda, maka Anda perlu memasukan
              nomor telepon yang anda gunakan saat mendaftarkan diri dan
              memasukkan kode verifikasi, yang kemudian akan dikirimkan secara
              otomatis oleh sistem kami melalui pesan singkat SMS atau WhatsApp
              ke nomor telepon Anda pada halaman login.
            </p>
          </li>
          <li>
            <p>
              Nomor telepon yang Anda berikan dapat digunakan pada 2 (dua)
              layanan Gass.co.id yakni Gass.co.id Menu dan Gass.co.id app
              (mencakup Page dan Store). Anda akan mendapatkan 2 (dua) akun yang
              berbeda.
            </p>
          </li>
          <li>
            <p>
              Untuk disclaimer: Kode verifikasi (OTP/One Time Password)
              dihasilkan secara otomatis oleh sistem kami. Kami tidak mengetahui
              dan tidak pernah meminta kode verifikasi Anda. Jangan pernah
              memberitahukan kode verifikasi Anda kepada siapapun bahkan kepada
              Kami atau pihak lain yang mengaku sebagai perwakilan Kami.
            </p>
          </li>
          <li>
            <p>
              Dengan melakukan pendaftaran, maka Anda menyatakan telah: (a)
              Menyetujui penggunaan dan pengelolaan data pribadi Anda oleh Kami,
              termasuk namun tidak terbatas pada pengungkapan kepada lembaga
              pemerintah dan instansi sepanjang diperlukan dan dilandasi oleh
              hukum dan ketentuan peraturan perundang-undangan yang berlaku, dan
              apabila menurut keyakinan Kami bahwa penggunaan Anda melanggar
              hukum dan ketentuan peraturan perundang-undangan yang berlaku; (b)
              Setuju dan mengikatkan diri pada Kebijakan Privasi Gass.co.id App;
              (c) Melindungi hak-hak Kami sehubungan dengan hak kekayaan
              intelektual dan hak-hak lainnya yang melekat pada Kami; (d)
              Mematuhi seluruh ketentuan hukum yang berlaku di wilayah Negara
              Republik Indonesia; dan (e) Sebelum melakukan pendaftaran, Anda
              sudah memastikan bahwa perangkat atau device (mobile phone, tab,
              dan sejenisnya) yang Anda gunakan kompatibel /mendukung penggunaan
              Situs dan Layanan.
            </p>
          </li>
          <li>
            <p>
              Anda setuju bahwa kami, berdasarkan Peraturan Menteri Komunikasi
              dan Informasi Republik Indonesia Nomor 5 Tahun 2020 tentang
              Penyelenggara Sistem Elektronik Lingkup Privat, sebagaimana telah
              diubah dengan Peraturan Menteri Komunikasi dan Informasi Republik
              Indonesia Nomor 10 Tahun 2021 tentang Perubahan atas Peraturan
              Menteri Komunikasi dan Informasi Republik Indonesia Nomor 5 Tahun
              2020 tentang Penyelenggara Sistem Elektronik Lingkup Privat, dapat
              memblokir atau menutup Akun Anda serta menghapus atau membuang
              segala Konten yang berkaitan dengan Akun Anda dari Layanan
              selambat-lambatnya dalam 1x24 jam setelah surat perintah Pemutusan
              Akses (take down) dari Menteri diterima.
            </p>
          </li>
          <li>
            <p>
              Kami memiliki seluruh hak untuk memblokir sementara, ataupun
              secara permanen, menghapus, menonaktifkan Akun Anda maupun
              menangguhkan dan/ atau menghentikan akses Anda terhadap Layanan
              atas kebijakan Kami sendiri dan untuk sebab apapun dengan
              memberikan pemberitahuan sebelumnya kepada Anda sesegera mungkin.
              Alasan dari pemblokiran, penghapusan, atau penonaktifan Akun Anda
              dapat berupa, termasuk namun tidak terbatas kepada:
            </p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <p>
                  Pelanggaran atau tidak patuh terhadap Kebijakan Privasi dan
                  S&amp;K ini maupun ketentuan perundang-undangan yang berlaku;
                </p>
              </li>
              <li>
                <p>
                  Penipuan atau pencurian (atau indikasi atau sangkaan
                  penipuan atau pencurian);
                </p>
              </li>
              <li>
                <p>
                  Kecurigaan adanya tindak kriminal atau pelanggaran (fraud);
                </p>
              </li>
              <li>
                <p>Transaksi barang ilegal;</p>
              </li>
              <li>
                <p>
                  Tindakan pelanggaran kesusilaan, pornografi, perjudian,
                  penghinaan/pencemaran nama baik, pengancaman dan pemerasan,
                  terorisme;
                </p>
              </li>
              <li>
                <p>
                  Tindakan pelanggaran terhadap Hak Kekayaan Intelektual yang
                  menjadi hak Kami sebagaimana dimaksud dalam Butir 10 S&amp;K
                  ini, termasuk namun tidak terbatas pada mencoba untuk
                  mengubah, menyalin, meniru, membongkar, atau melakukan{" "}
                  <em>reverse engineering</em> untuk program komputer atau
                  Situs;
                </p>
              </li>
              <li>
                <p>
                  Anda dan/atau pihak lain, yang berdasarkan pertimbangan Kami
                  akan mengakibatkan kerugian dan/atau kerusakan terhadap
                  Kami, afiliasi Kami maupun pihak ketiga yang terikat
                  perjanjian dengan Kami;
                </p>
              </li>
              <li>
                <p>
                  Berdasarkan pertimbangan Kami, Aplikasi dan/atau Layanan
                  disalahgunakan untuk melakukan pelanggaran terhadap
                  ketentuan hukum yang berlaku di wilayah Republik Indonesia
                  yang dilakukan oleh Anda dan/atau pihak ketiga;
                </p>
              </li>
              <li>
                <p>
                  Anda memberikan informasi yang tidak akurat, salah atau
                  menyesatkan;
                </p>
              </li>
              <li>
                <p>
                  Melakukan perbuatan yang tidak pantas, ancaman, atau hinaan
                  terhadap Gass.co.id maupun pihak lainnya yang dapat
                  mempengaruhi reputasi dan nama baik Gass.co.id;
                </p>
              </li>
              <li>
                <p>
                  Anda menolak memberikan informasi yang Kami perlukan untuk
                  keperluan pendaftaran Akun Anda;
                </p>
              </li>
              <li>
                <p>
                  Adanya gangguan teknis yang mempengaruhi sistem dan tata
                  kelola internal Gass.co.id;
                </p>
              </li>
              <li>
                <p>
                  Anda termasuk ke dalam “daftar hitam” atau “daftar
                  pengamatan” oleh pemerintah suatu negara atau organisasi
                  internasional;
                </p>
              </li>
              <li>
                <p>
                  Adanya ketentuan yang mewajibkan hal tersebut berdasarkan
                  ketentuan hukum yang berlaku.
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <article>
          <p>
            Peringatan tertulis mungkin akan Kami berikan sehubungan dengan
            pelanggaran dan ketidakpatuhan Anda terhadap ketentuan di atas,
            melalui surel atau media lainnya yang Kami tentukan dari waktu ke
            waktu. Dengan pemberitahuan sebelumnya kepada Pengguna, Gass.co.id
            berhak menghapus atau melakukan pengarsipan (archive) pada data-data
            di Akun Pengguna, jika data storage telah melebihi kapasitas
            maksimum.
          </p>
        </article>
      </section>

      <section>
        <h2>7. Biaya dan Pajak</h2>
        <ol>
          <li>
            <p>
              Gass.co.id akan membebankan biaya untuk penggunaan Layanan yang
              ditetapkan di Situs Gass.co.id tergantung pada jenis Layanan
              Gass.co.id dan dapat berubah. Anda dapat menemukan rincian biaya
              Layanan Gass.co.id sebagai berikut:
            </p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <p>
                  Gass.co.id Page: Gass.co.id Page tidak membebankan biaya
                  bulanan atau tahunan, tetapi hanya membebankan biaya
                  platform. Informasi lebih lanjut mengenai biaya platform
                  Gass.co.id Page dapat dilihat di halaman{" "}
                  <a
                    href="https://gass.co.id/article/biaya-platform-fitur-pembayaran"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://gass.co.id/article/biaya-platform-fitur-pembayaran
                  </a>
                  .
                </p>
              </li>
              <li>
                <p>
                  Gass.co.id Store: Informasi lebih lanjut mengenai harga
                  Gass.co.id Store dapat dilihat di halaman{" "}
                  <a
                    href="https://gass.co.id/article/biaya-platform-Gass.co.id-store"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://gass.co.id/article/biaya-platform-Gass.co.id-store
                  </a>
                  .
                </p>
              </li>
              <li>
                <p>
                  Gass.co.id Wholesale: Informasi lebih lanjut mengenai harga
                  Gass.co.id Wholesale dapat dilihat di halaman{" "}
                  <a
                    href="https://gass.co.id/article/tentang-Gass.co.id-wholesale"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://gass.co.id/article/tentang-Gass.co.id-wholesale
                  </a>
                  .
                </p>
              </li>
              <li>
                <p>
                  Gass.co.id Menu: Gass.co.id Menu tidak memungut biaya
                  bulanan atau tahunan, melainkan hanya membebankan biaya
                  transaksi. Informasi lebih rinci dapat ditemukan setelah
                  Pengguna menghubungi kami di{" "}
                  <a href="https://gass.co.id/ajak" target="_blank" rel="noopener noreferrer">
                    https://gass.co.id/ajak
                  </a>{" "}
                  dan mengisi formulir.
                </p>
              </li>
              <li>
                <p>
                  Gass.co.id Omni: Informasi lebih lanjut mengenai harga
                  Gass.co.id Omni dapat dilihat di laman{" "}
                  <a
                    href="https://gass.co.id/article/top-up-saldo-Gass.co.id"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://gass.co.id/article/top-up-saldo-Gass.co.id
                  </a>
                  .
                </p>
              </li>
              <li>
                <p>
                  Gass.co.id Market: Gass.co.id Market akan mengenakan biaya
                  sesuai dengan tools dan extensions yang Anda pilih sesuai
                  dengan kebutuhan. Biaya tersebut menyesuaikan dengan
                  ketentuan dari pihak penyedia layanan tools dan extension.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Pengguna akan sepenuhnya bertanggung jawab dan membebaskan
              Gass.co.id dari setiap klaim pembayaran pajak, bea, atau pungutan
              pemerintah lainnya, serta ongkos yang mungkin dikenakan pada
              Layanan Gass.co.id.
            </p>
          </li>
          <li>
            <p>
              Apabila di kemudian hari kami mengubah biaya yang dikenakan untuk
              penggunaan Layanan (sebagaimana dijelaskan dalam poin 1 di atas)
              maka kami akan memberitahukannya sesegera mungkin atau paling
              lambat dalam 14 hari kerja kepada Anda sebelum berlakunya
              perubahan tersebut. Biaya lainnya yang dikenakan kepada Anda oleh
              pihak ketiga, misalnya layanan sistem pembayaran dalam hal ini,
              akan diinformasikan kepada Anda berdasarkan ketentuan dan
              kebijakan dari pihak tersebut kepada Anda.
            </p>
          </li>
        </ol>
      </section>

      <section>
        <h2>8. Kerahasiaan Akun</h2>
        <ol>
          <li>
            <p>
              Pengguna bertanggungjawab atas keamanan dan kerahasiaan dari kode
              OTP yang telah dikirimkan ke nomor seluler pribadi Pengguna dan
              informasi lainnya sehubungan dengan akun Pengguna yang terdapat
              didalam <b>“Informasi Registrasi”.</b>
            </p>
          </li>
          <li>
            <p>
              Mohon menginformasikan kepada Kami jika Anda tidak lagi memiliki
              kontrol atas Akun Anda, sebagai contoh Akun Anda dengan cara
              bagaimanapun diretas (hack) atau telepon Anda dicuri, sehingga
              Kami dapat membatalkan akun Anda dengan sebagaimana mestinya.
              Mohon diperhatikan bahwa Anda bertanggung jawab atas penggunaan
              Akun Anda dan Anda tetap dapat dimintakan pertanggungjawaban
              meskipun Akun Anda tersebut disalahgunakan oleh orang lain.
            </p>
          </li>
          <li>
            <p>
              Dalam hal terjadi pengungkapan atas kata sandi Pengguna, dengan
              cara apapun, yang mengakibatkan setiap penggunaan yang tidak sah
              atau tanpa kewenangan atas Akun atau identitas Pengguna, maka
              Gass.co.id akan memproses segala sesuatu yang berhubungan dengan
              penggunaan Aplikasi berdasarkan Informasi Registrasi dan tetap
              dianggap sah, kecuali Pengguna telah melaporkan kepada Kami
              mengenai adanya akses ilegal tehadap Akun Pengguna, atau adanya
              penyalahgunaan terhadap Informasi Registrasi pada saat atau
              setelah terjadinya penggunaan yang tidak sah atau tanpa kewenangan
              tersebut kepada Gass.co.id melalui email:{" "}
              <a href="mailto:cs@gass.co.id">cs@gass.co.id</a>.
            </p>
          </li>
          <li>
            <p>
              Kami tidak bertanggung jawab atas kerugian atau tuntutan yang
              timbul sebagai akibat dari kelalaian Pengguna dan atas
              penyalahgunaan sistem Gass.co.id untuk kepentingan pribadi
              Pengguna.
            </p>
          </li>
        </ol>
      </section>

      <section>
        <h2>9. Ketentuan Khusus</h2>
        <ol>
          <li>
            <p>Syarat Menjadi Pengguna di Gass.co.id</p>
            <p>
              Gass.co.id terbuka bagi semua individu dan/atau perusahaan baik
              dalam bentuk badan usaha atau badan hukum, Commanditaire
              Venoontschap (CV), Firma hingga Perseroan Terbatas dan bentuk
              lainnya untuk menjadi Pengguna sesuai dengan S&amp;K.
            </p>
          </li>
          <li>
            <p>Pengguna Menjamin Bahwa:</p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <p>
                  Pengguna tidak akan melakukan tindakan hukum, memasarkan
                  dan/atau melakukan transaksi atas barang yang tidak ada atau
                  ilegal, menjual produk dalam kondisi cacat atau terlibat
                  dalam sengketa, klaim, tuntutan hukum, penangguhan
                  pembayaran utang, penyelidikan dan tindak pidana.
                </p>
              </li>
              <li>
                <p>
                  Pengguna bersedia menerima peringatan dan/atau gugatan dari
                  Gass.co.id, apabila terbukti memasarkan dan menjual produk
                  atau melakukan tindakan yang dinyatakan melanggar hukum dan
                  peraturan yang berlaku.
                </p>
              </li>
              <li>
                <p>
                  Pengguna akan selalu menyediakan, memelihara dan
                  memperbaharui informasi Pengguna dan produk yang akurat dan
                  lengkap yang bisa diandalkan oleh sistem dan pembeli.
                </p>
              </li>
              <li>
                <p>
                  Pengguna memiliki izin untuk menjual dan menggunakan Konten
                  yang dibagikan di Situs.
                </p>
              </li>
              <li>
                <p>
                  Untuk keperluan verifikasi Pengguna dapat menghubungi
                  Gass.co.id melalui{" "}
                  <a href="mailto:cs@gass.co.id">cs@gass.co.id</a>, Kami akan
                  mengakomodasi dan menerima masalah dan keluhan Pengguna.
                </p>
              </li>
              <li>
                <p>
                  Pengguna bertanggung jawab untuk menjaga kerahasiaan data
                  dan akses Pengguna ke Aplikasi yang terdiri dari nomor
                  handphone yang digunakan dan kata sandi. Apabila Pengguna
                  kehilangan akses ke Gass.co.id, Pengguna dapat menghubungi
                  Gass.co.id di{" "}
                  <a href="mailto:cs@gass.co.id">cs@gass.co.id</a>.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>Hak Gass.co.id</p>
            <p>Gass.co.id memiliki hak dan kebijakannya sendiri untuk:</p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <p>
                  Menghentikan, menangguhkan, menonaktifkan, dan/atau menghapus
                  situs web apa pun yang di hosting di servernya yang dianggap
                  tidak pantas.
                </p>
              </li>
              <li>
                <p>
                  Meninjau akun apa pun atau bandwidth yang berlebihan dan untuk
                  menangguhkan layanan ke akun yang telah melebihi level yang
                  diizinkan.
                </p>
              </li>
              <li>
                <p>
                  Menghentikan akun apa pun karena tidak membayar biaya, karena
                  memberikan informasi akun palsu atau informasi pembayaran
                  palsu.
                </p>
              </li>
              <li>
                <p>
                  Menghentikan akun apa pun jika Kontennya di Situs
                  menghasilkan, atau merupakan subjek, tindakan hukum atau
                  tindakan hukum berbahaya terhadap Gass.co.id atau afiliasi
                  atau mitranya, terlepas dari apakah tindakan hukum atau
                  tindakan hukum berbahaya tersebut ditentukan dengan atau tanpa
                  layanan kemudian.
                </p>
              </li>
              <li>
                <p>
                  Menghentikan akun apa pun untuk email komersial yang tidak
                  diminta (<b>“Spam”</b>), akses ilegal ke komputer atau
                  jaringan lain (misalnya peretasan), distribusi virus internet
                  atau aktivitas merusak serupa, aktivitas sah atau tidak sah
                  yang Gass.co.id anggap berbahaya bagi operasi atau reputasi
                  pelanggan, atau untuk pelanggaran apa pun dari S&amp;K ini.
                </p>
              </li>
              <li>
                <p>
                  Menangguhkan Layanan setiap saat untuk periode apa pun jika
                  perlu, tanpa penalti atau kewajiban kepada diri sendiri.
                </p>
              </li>
              <li>
                <p>
                  Menangguhkan Layanan dan tidak terbatas pada layanan situs
                  web, dengan keadaan tertentu, termasuk:
                </p>
                <ol style={{ listStyleType: "lower-roman" }}>
                  <li>
                    <p>
                      Menolak atau membatalkan pesanan Anda setiap saat karena
                      alasan tertentu termasuk namun tidak terbatas pada:
                      ketersediaan produk atau layanan, kesalahan dalam
                      deskripsi atau harga produk atau layanan, kesalahan
                      dalam pesanan Anda atau alasan lainnya.
                    </p>
                  </li>
                  <li>
                    <p>
                      Menolak atau membatalkan pesanan Anda jika diduga
                      terjadi penipuan atau transaksi yang tidak sah atau
                      ilegal.
                    </p>
                  </li>
                  <li>
                    <p>
                      Menangguhkan pencairan dana yang ditimbulkan atas
                      pesanan yang diindikasikan tidak sah atau illegal.
                    </p>
                  </li>
                </ol>
              </li>
              <li>
                <p>
                  Memotong dana yang dicairkan sejumlah selisih dari biaya kirim
                  barang sebenarnya dengan biaya kirim yang dibayarkan oleh
                  pelanggan, jika ditemukan perbedaan biaya kirim yang
                  disebabkan oleh perbedaan berat barang yang dikirim dengan
                  berat barang yang dimasukan pada deskripsi produk yang dijual
                  di Toko <em>Online</em>.
                </p>
              </li>
              <li>
                <p>
                  Menghapus <em>watermarks</em>, label, atau pemberitahuan
                  kepemilikan lainnya yang termasuk dalam Konten atau upaya
                  untuk mengubah Konten yang diperoleh melalui Situs Gass.co.id,
                  termasuk modifikasi yang bertujuan untuk menyamarkan atau
                  mengubah indikasi kepemilikan atau sumber Konten.
                </p>
              </li>
              <li>
                <p>
                  Memperoleh biaya dari <em>Merchant</em>.
                </p>
              </li>
              <li>
                <p>
                  Dengan menggunakan Situs ini, Gass.co.id secara otomatis
                  memperoleh persetujuan Anda. Apabila Gass.co.id menangguhkan
                  Layanan untuk sementara waktu karena alasan teknis atau untuk
                  memelihara peralatan atau fasilitas jaringan, sebagaimana
                  dianggap perlu oleh Gass.co.id, maka Anda dengan ini
                  membebaskan Gass.co.id dari segala tuntutan dan/atau gugatan
                  terkait penangguhan Layanan tersebut.
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </section>

      <section>
        <h2>10. Pembelian dan Pembayaran/Pencarian Dana</h2>
        <article>
          <p>
            Gass.co.id akan melakukan pencairan Dana dengan ketentuan berikut:
          </p>
        </article>
        <ul>
          <li>
            <p>
              Pencairan dana hanya akan dilakukan melalui Rekening Bank yang{" "}
              <em>Merchant</em> sudah informasikan pada saat proses pendaftaran
              atau pembuatan Toko <em>Online</em> sebagai rekening penerima
              dana.
            </p>
          </li>
          <li>
            <p>
              Pencairan dana akan dilakukan oleh Gass.co.id dengan kondisi
              pesanan sudah melalui proses pengantaran dengan didukung adanya
              bukti pengambilan barang dari <em>Merchant</em> atau status
              pesanan yang sudah berubah menjadi barang sedang dikirim dan
              dengan keterangan pesanan sedang dalam transit.
            </p>
          </li>
          <li>
            <p>
              Pencairan dana selanjutnya akan dilakukan oleh Gass.co.id kepada
              pihak Merchant, disesuaikan dengan jenis pembayaran yang digunakan
              oleh pelanggan, sebagai berikut:
            </p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <p>
                  Pembayaran dengan <em>E-wallet</em>
                </p>
              </li>
              <li>
                <p>
                  Pembayaran dengan Bank transfer/<em>Virtual Account</em>
                </p>
              </li>
              <li>
                <p>Pembayaran dengan Kartu Kredit</p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Pencairan dana hanya akan dilakukan untuk pesanan dengan status
              pesanan sedang dalam transit atau pesanan sudah diambil oleh pihak
              penyedia layanan pengiriman atau pesanan sudah dikirim oleh
              layanan pengiriman yang dimiliki oleh Toko Online jika pesanan
              menggunakan pilihan pengiriman kurir Toko.
            </p>
          </li>
          <li>
            <p>
              Pencairan dana dapat ditangguhkan dengan keadaan tertentu
              sebagaimana berhak dilakukan oleh Gass.co.id (pada bagian 4, 6 dan
              8) dengan alasan tertentu jika Merchant dicurigai melakukan
              aktivitas ilegal, dengan masa penangguhan dana sekurang-kurangnya
              dalam kurun waktu 6 bulan dan penangguhan dapat dibatalkan jika
              tidak terdapat laporan lebih lanjut atau Merchant dapat
              memverifikasi transaksi yang dicurigai.
            </p>
          </li>
        </ul>
      </section>

      <section>
        <h2>11. Tautan Eksternal</h2>
        <article>
          <p>
            Situs ini mungkin berisi tautan ke situs internet lain yang dimiliki
            dan dioperasikan oleh vendor pihak ketiga dan pihak ketiga lainnya (
            <b>“Link Eksternal”</b>). Gass.co.id tidak memiliki kendali atas
            Link Eksternal maupun isinya. Oleh karenanya, Anda mengakui dan
            setuju bahwa Kami tidak akan bertanggung jawab atas ketersediaan
            Link Eksternal tersebut, dan tidak mendukung dan tidak bertanggung
            jawab atau berkewajiban apapun atas konten, iklan, produk, materi,
            maupun informasi apa pun yang terdapat dalam Link Eksternal
            tersebut. Anda juga mengakui dan memahami bawa anda membebaskan
            Gass.co.id dari segala tuntutan dan tanggung jawab atas setiap
            konten, iklan, produk, Materi, maupun informasi yang Anda unggah
            atau tersedia pada Link Eksternal yang mungkin melanggar S&amp;K ini
            serta peraturan perundang-undangan berlaku. Anda selanjutnya
            mengakui dan setuju bahwa Kami tidak akan bertanggung jawab atau
            berkewajiban, secara langsung atau tidak langsung, atas kerusakan
            atau kerugian yang disebabkan atau dicurigai disebabkan oleh atau
            sehubungan dengan penggunaan atau ketergantungan pada konten, barang
            atau layanan yang tersedia pada atau melalui Link Eksternal.
            Gass.co.id tidak membuat pernyataan atau jaminan dalam bentuk apa
            pun, tersurat maupun tersirat, sehubungan dengan pengoperasian situs
            ini atau informasi, konten, materi, atau produk yang termasuk dalam
            situs ini. Gass.co.id selalu memberikan upaya terbaik terkait
            keamanan penggunaan Situs dan Layanan Gass.co.id, penyaringan
            Akun-Akun serta peninjauan dan pengawasan Konten, namun hal ini
            tidak mengesampingkan kewajiban Anda untuk menerapkan prinsip
            kehati-hatian dalam penggunaan Situs ini dan segala isinya oleh Anda
            dan karenanya menanggung risiko Anda sendiri. Gass.co.id tidak dapat
            menjamin sepenuhnya bahwa Situs ini dan/atau layanannya tidak akan
            terganggu, tepat waktu, aman, atau bebas dari kesalahan. Anda wajib
            memberitahu Gass.co.id sesegera mungkin apabila mengalami gangguan
            sebagaimana disebutkan di atas sehingga Gass.co.id dapat berusaha
            menangani gangguan tersebut.
          </p>
        </article>
      </section>

      <section>
        <h2>12. Hak Kekayaan Intelektual (HKI)</h2>
        <ul>
          <li>
            <p>
              Segala sesuatu mengenai Situs Gass.co.id, termasuk pada tulisan,
              gambar, logo, tombol, konten, fitur, perangkat lunak (software)
              telah memiliki Izin dan tidak dijual maupun dialihkan. Gass.co.id
              memiliki semua hak-hak yang tidak dinyatakan secara tegas kepada
              Pengguna dalam Perjanjian ini. Layanan-layanan dilindungi oleh
              paten, hak cipta, merek, rahasia dagang dan perlindungan lain yang
              berkaitan dengan hukum dan peraturan perundang-undangan di bidang
              Hak Kekayaan Intelektual baik yang sudah ada atau yang akan diatur
              di kemudian hari.
            </p>
          </li>
          <li>
            <p>
              Untuk tujuan Perjanjian ini, <b>“Hak Kekayaan Intelektual”</b>{" "}
              berarti semua hak paten, hak cipta, merek pada berbagai produk,
              rahasia dagang, dan hak-hak kekayaan intelektual lainnya yang
              telah ada saat ini atau di kemudian hari dan semua
              permohonan-permohonan daripadanya dan pendaftaran-pendaftaran,
              pembaharuan-pembaharuan dan perpanjangan-perpanjangan dari
              padanya, berdasarkan hukum Negara Republik Indonesia.
            </p>
          </li>
          <li>
            <p>
              Tidak ada ketentuan di dalam S&amp;K ini yang dapat ditafsirkan
              sebagai pemberian maupun pengalihan hak/lisensi atas Hak Kekayaan
              Intelektual apapun kepada Anda maupun pihak lainnya, baik sebagian
              maupun seluruhnya, baik tersirat maupun tersurat, untuk
              menggunakan, memiliki, menyalin, mereproduksi, mempublikasikan,
              mengeksploitasi, mendistribusikan, menjual, mengalihkan,
              menampilkan di muka umum, membuat ulang, mentransmisikan,
              memindahkan, menyiarkan, membongkar bagian manapun, memodifikasi
              dan/atau melakukan hal-hal lainnya yang dapat mengurangi hak-hak
              yang terkandung dalam Hak Kekayaan Intelektual sebagaimana
              dimaksud, kecuali dinyatakan lain secara tegas di dalam S&amp;K ini.
              Anda dengan ini menerima dan menyetujui bahwa mengunduh setiap
              bagian apapun dari Hak Kekayaan Intelektual tidak memberikan Anda
              hak atas Hak Kekayaan Intelektual tersebut.
            </p>
          </li>
          <li>
            <p>
              Anda setuju untuk tidak menggunakan Hak Kekayaan Intelektual
              Gass.co.id tanpa persetujuan tertulis sebelumnya dari Kami. Anda
              mengakui bahwa setiap upaya nyata atau pelanggaran ketentuan yang
              terkait dengan Hak Kekayaan Intelektual akan mengakibatkan
              penghentian semua hak Pengguna terkait Layanan Gass.co.id.
            </p>
          </li>
        </ul>
      </section>

      <section>
        <h2>13. Keamanan</h2>
        <article>
          <p>
            Kami telah mengimplementasikan langkah-langkah teknis yang dibuat
            untuk mengamankan informasi pribadi Anda dari kehilangan insidentil
            dan dari akses, pengunduhan, perubahan, atau pengungkapan yang tidak
            berwenang. Bagaimanapun juga, Kami tidak menjamin bahwa pihak ketiga
            yang tidak berwenang tidak akan berhasil menembus perlindungan
            berdasarkan langkah-langkah tersebut atau menggunakan informasi
            pribadi untuk tujuan yang tidak sesuai. Anda mengetahui dan
            menyetujui bahwa Anda menyediakan informasi Anda dengan risikonya
            sendiri.
          </p>
        </article>
      </section>

      <section>
        <h2>14. Informasi Rahasia</h2>
        <ol>
          <li>
            <p>
              <b>“Informasi Rahasia”</b> akan mencakup, tetapi tidak terbatas
              pada, setiap dan semua informasi yang terkait dengan bisnis suatu
              pihak dan tidak diketahui publik, termasuk informasi bisnis
              tertentu, proses dan formula teknis, perangkat lunak, daftar
              pelanggan, daftar calon pelanggan, nama , alamat dan informasi
              lainnya mengenai pelanggan dan calon pelanggan, desain produk,
              penjualan, biaya (termasuk biaya pemrosesan yang relevan), kontrak
              kerjasama, dan informasi keuangan lainnya yang tidak
              dipublikasikan, rencana bisnis dan data pemasaran, dan informasi
              rahasia dan hak milik lainnya, baik atau tidak ditandai sebagai
              rahasia atau hak milik yang diungkapkan oleh suatu pihak (
              <b>“Pihak Pengungkap”</b>) kepada pihak lainnya (
              <b>“Pihak Penerima”</b>). Informasi Rahasia Gass.co.id mencakup
              semua informasi yang Anda terima terkait dengan kami, atau
              Layanan, yang tidak diketahui oleh masyarakat umum termasuk
              informasi terkait program dan praktik keamanan kami.
            </p>
          </li>
          <li>
            <p>
              Masing-masing pihak setuju untuk menggunakan Informasi Rahasia
              pihak lain semata-mata seperlunya: untuk melaksanakan kewajibannya
              berdasarkan S&amp;K ini dan sesuai dengan kewajiban lainnya dalam S&amp;K
              ini. Pengguna memahami dan menyetujui bahwa Gass.co.id juga akan
              menggunakan Informasi Rahasia milik pengguna untuk melaksanakan
              Layanan. Masing-masing pihak setuju bahwa pihaknya akan mengambil
              semua langkah yang wajar, setidaknya secara substansial setara
              dengan langkah yang diambil untuk melindungi informasi
              kepemilikannya sendiri, untuk mencegah duplikasi, pengungkapan,
              atau penggunaan Informasi Rahasia tersebut, selain dari
              pengungkapan: (i) kepada pejabat, karyawan, agen, penasehat
              (counsel) dan subkontraktor (<b>“Pihak yang Diizinkan”</b>) dari
              Pihak Penerima yang harus memiliki akses ke Informasi Rahasia
              tersebut untuk melaksanakan kewajibannya, dimana Pihak yang
              Diizinkan tersebut akan tunduk dan terikat pada kewajiban
              kerahasiaan dalam S&amp;K ini; atau (ii) oleh Pihak Penerima
              sebagaimana disyaratkan oleh ketentuan perundang-undangan,
              otoritas pemerintahan yang berwenang, maupun perintah pengadilan
              mana pun dengan yurisdiksi yang tepat atas Pihak Penerima tersebut
              , dengan ketentuan bahwa, jika diizinkan secara hukum dan dapat
              dilaksanakan, maka Pihak Penerima akan segera memberikan
              pemberitahuan tertulis kepada Pihak Pengungkap dan menggunakan
              upaya terbaiknya yang wajar secara komersial untuk memastikan
              bahwa informasi yang diungkapkan tersebut akan diperlakukan
              selayaknya informasi rahasia.
            </p>
          </li>
          <li>
            <p>
              Informasi Rahasia tidak akan mencakup informasi apa pun yang dapat
              dibuktikan oleh Pihak Penerima bahwa informasi tersebut: (A) sudah
              berada dalam domain publik, atau sudah diketahui oleh atau
              dimiliki oleh Pihak Penerima, pada saat pengungkapan informasi
              tersebut oleh Pihak Pengungkap; (B) dikembangkan secara independen
              oleh Pihak Penerima tanpa menggunakan atau merujuk ke Informasi
              rahasia Pihak Pengungkap, dan tanpa melanggar ketentuan S&amp;K ini;
              atau (C) selanjutnya diperoleh secara sah oleh Pihak Penerima dari
              sumber selain dari Pihak Pengungkap tanpa melanggar ketentuan apa
              pun dari S&amp;K ini.
            </p>
          </li>
        </ol>
      </section>

      <section>
        <h2>15. Penggunaan Yang Tidak Berwenang atau Ilegal</h2>
        <article>
          <p>
            Gass.co.id tidak mengizinkan penggunaan Spam untuk mempromosikan
            produk atau Layanan. Setiap pelanggan yang terlibat dalam pengiriman
            Spam melalui Gass.co.id atau mempromosikan informasi di situs web
            yang di hosting oleh Gass.co.id akan dianggap telah melanggar S&amp;K
            ini dan akan segera ditangguhkan dari Layanan. Penggunaan Konten
            dan/atau Layanan Anda harus sesuai dengan hukum dan peraturan yang
            berlaku di Indonesia, khususnya (namun tidak terbatas pada)
            Undang-Undang Nomor 28 Tahun 2014 tentang Hak Cipta, Undang-Undang
            Nomor 20 Tahun 2016 tentang Merek Dagang dan Indikasi Geografis,
            Undang-Undang Nomor 13 Tahun 2016 tentang Paten, Undang-Undang Nomor
            11 Tahun 2008 tentang Informasi dan Transaksi Elektronik,
            sebagaimana telah diubah dengan Undang-Undang Nomor 19 Tahun 2016
            tentang Perubahan Atas Undang-Undang Nomor 11 Tahun 2008 tentang
            Informasi dan Transaksi Elektronik, Undang-Undang Nomor 8 Tahun 1999
            tentang Perlindungan Konsumen, dan Undang-Undang Nomor 27 Tahun 2022
            tentang Pelindungan Data Pribadi.
          </p>
        </article>
        <article>
          <p>
            Anda bertanggung jawab untuk memastikan bahwa penggunaan Anda atas
            Konten dan Layanan tidak menggunakan sistem atau sumber daya
            jaringan yang berlebihan yang mengganggu penggunaan normal Layanan
            melalui, tetapi tidak terbatas pada, membuat banyak proses, atau
            menghabiskan banyak memori, CPU, atau kapasitas bandwidth yang
            berlebihan. Berikut ini adalah daftar konten non-eksklusif, dan
            perilaku yang dilarang (tetapi tidak terbatas pada) oleh Gass.co.id:
          </p>
        </article>
        <ul>
          <li>
            <p>
              Konten yang berisi <em>link</em> seperti: pornografi, konten
              dewasa, materi dengan bahasa kotor.
            </p>
          </li>
          <li>
            <p>
              Konten yang membenarkan, mempromosikan, maupun berisi{" "}
              <em>link</em> pembajakan (<em>hacking</em>), utilitas terkait,
              atau informasi terkait pembajakan lainnya, baik untuk tujuan
              pendidikan atau bukan.
            </p>
          </li>
          <li>
            <p>
              Konten yang telah dipromosikan melalui pengiriman Spam atau skema
              penipuan surat, atau halaman yang mempromosikan atau mengizinkan
              pengiriman <em>Spam</em>.
            </p>
          </li>
          <li>
            <p>
              Pengiriman email massal yang berasal dari server kami yang
              didistribusikan ke penerima tidak dikenal yang meminta produk atau
              layanan, atau email massal bukan berasal dari server kami yang
              didistribusikan ke penerima tidak dikenal yang meminta produk atau
              layanan terkait dengan akun Gass.co.id akan mengakibatkan
              penangguhan akun secara langsung.
            </p>
          </li>
          <li>
            <p>
              Konten yang sangat menyinggung komunitas, termasuk ekspresi
              mencolok dari fanatisme, prasangka, rasisme, kebencian atau sumpah
              serapah yang berlebihan, atau memposting materi yang tidak
              senonoh, kotor, kasar, atau tidak menyenangkan.
            </p>
          </li>
          <li>
            <p>Konten yang mengeksploitasi anak di bawah usia 18 tahun.</p>
          </li>
          <li>
            <p>
              Konten yang menjual atau mempromosikan produk atau layanan yang
              melanggar hukum di lokasi tempat konten tersebut diposting atau
              diterima.
            </p>
          </li>
          <li>
            <p>
              Konten yang melanggar hak cipta, paten, merek dagang, merek
              layanan, nama dagang, rahasia dagang, atau hak kekayaan
              intelektual pihak ketiga lainnya.
            </p>
          </li>
          <li>
            <p>
              Konten yang mempromosikan email penipuan, skema pemasaran
              berjenjang (piramida), atau aktivitas ilegal atau curang lainnya.
            </p>
          </li>
          <li>
            <p>
              Merancang, mengkompilasi balik (<em>reverse engineering</em>) atau
              memperoleh kode sumber atau struktur atau urutan layanan, solusi,
              atau teknologi Gass.co.id dalam bentuk apa pun.
            </p>
          </li>
          <li>
            <p>
              Rekayasa ulang, kompilasi balik (<em>reverse engineering</em>),
              atau penurunan kualitas kode sumber atau struktur atau urutan kata
              kunci akses individu dari Situs Web Pelanggan (atau halaman yang
              terkandung di dalamnya).
            </p>
          </li>
          <li>
            <p>
              Konten yang berisi tindakan yang dapat dianggap sebagai tindakan
              kriminal di wilayah pelanggan. Misalnya konten terkait obat-obatan
              terlarang, senjata api, barang curian, barang selundupan, layanan
              perjudian, pemerasan dan terorisme dan hal apa pun yang dilarang
              oleh undang-undang pelanggan setempat.
            </p>
          </li>
        </ul>
        <article>
          <p>
            Apabila Kami secara beralasan mencurigai bahwa Akun Anda telah
            digunakan untuk tujuan yang tidak berwenang, ilegal, atau terkait
            dengan tindak pidana, Anda dengan ini memberikan Kami kewenangan
            untuk membagi dan mengungkapkan informasi tentang Anda, Akun Anda,
            dan setiap transaksi Anda tersebut kepada penegak hukum.
          </p>
        </article>
      </section>

      <section>
        <h2>16. Ganti Rugi dan Batasan Tanggung Jawab</h2>
        <ol>
          <li>
            <p>
              Anda berkewajiban untuk melindungi, memberikan kompensasi dengan
              segera atas permintaan Gass.co.id, dan membebaskan Gass.co.id dan
              afiliasinya, termasuk juga Para Pemegang Saham, Direksi, Dewan
              Komisaris, karyawan, agen dan perwakilan dari Gass.co.id dan
              afiliasinya ( “Pihak yang Dilindungi” ) dari dan terhadap segala
              kerugian, tuntutan, klaim, pajak, kewajiban, dan/atau biaya proses
              hukum, serta biaya (termasuk biaya pengacara dan pengeluaran yang
              wajar) (baik disebabkan oleh klaim pihak ketiga maupun tidak) yang
              timbul dan dikeluarkan oleh Pihak yang Dilindungi yang disebabkan
              atau terkait dengan:
            </p>
            <ol style={{ listStyleType: "lower-roman" }}>
              <li>
                <p>
                  ketidakakuratan pernyataan atau jaminan apa pun yang Anda
                  buat dalam S&amp;K ini sejak tanggal dibuat atau dianggap
                  dibuat; dan
                </p>
              </li>
              <li>
                <p>
                  setiap pelanggaran Anda terhadap perjanjian, kewajiban atau
                  kesepakatan masing-masing berdasarkan S&amp;K ini (secara
                  bersama-sama disebut “Kerugian” ), antara lain karena:
                </p>
                <ul>
                  <li>
                    <p>
                      Kerugian yang timbul dari informasi yang tidak valid,
                      tidak akurat atau tidak lengkap yang Anda berikan;
                    </p>
                  </li>
                  <li>
                    <p>
                      Kerugian yang timbul dari informasi yang tidak valid,
                      tidak akurat, tidak lengkap tentang produk dan/atau
                      transaksi produk di Platform yang Anda berikan;
                    </p>
                  </li>
                  <li>
                    <p>
                      Produk yang Anda jual adalah palsu, melanggar hak
                      kekayaan intelektual pihak ketiga lainnya, tidak
                      sesuai dengan ketentuan peraturan perundang-undangan
                      yang berlaku, dan/atau bertentangan dengan ketentuan
                      yang berlaku di Gass.co.id (seperti Ketentuan
                      Penggunaan Gass.co.id);
                    </p>
                  </li>
                  <li>
                    <p>
                      Penyalahgunaan Data Pribadi Pengguna atau Pembeli oleh
                      Anda;
                    </p>
                  </li>
                  <li>
                    <p>
                      Kegagalan Anda dalam menggunakan Platform yang terjadi
                      karena kelalaian Anda dan/atau pihak lain dalam
                      menjaga kerahasiaan akun Anda di Platform termasuk
                      namun tidak terbatas pada peminjaman akun kepada pihak
                      lain, memberikan akses kata sandi kepada pihak lain,
                      memberikan kode verifikasi kepada pihak lain,
                      mengakses tautan dari pihak lain yang menyebabkan akun
                      Anda diakses tanpa persetujuan dan/atau sepengetahuan
                      Anda dan dapat mengakibatkan kerugian bagi pembeli
                      atau diri Anda sendiri atau Pihak yang Dilindungi;
                    </p>
                  </li>
                </ul>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Kegagalan atau ketidakmampuan Anda untuk menerapkan S&amp;K ini atas
              karena perubahan hukum dan peraturan, keputusan pengadilan
              (termasuk namun tidak terbatas pada kebangkrutan atau diberi
              keputusan pailit, termasuk wanprestasi), atau keputusan
              pemerintah, pencabutan atau penghentian sementara izin usaha,
              dibubarkan atau dilikuidasi baik secara sukarela maupun paksa
              (kecuali untuk tujuan peleburan atau merger), dan/atau aset
              utamanya disita, maka Anda berkewajiban bertanggung jawab atas
              permasalahan hukum yang terjadi dan berkewajiban membebaskan
              Gass.co.id dan afiliasinya dari segala tuntutan dan/atau klaim
              yang timbul.
            </p>
          </li>
          <li>
            <p>
              Gass.co.id dan afiliasinya tidak bertanggung jawab mengenai
              hal-hal berikut:
            </p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <p>
                  Barang yang dibeli ternyata cacat, rusak atau tidak sesuai
                  dengan deskripsi yang dicantumkan di Toko Online;
                </p>
              </li>
              <li>
                <p>
                  Pelanggan tidak membayar atas barang yang dibeli pada Toko
                  Online;
                </p>
              </li>
              <li>
                <p>
                  Hal ini adalah tanggung jawab Anda sepenuhnya untuk
                  menyelesaikan pengembalian uang dan barang kepada pelanggan;
                </p>
              </li>
              <li>
                <p>
                  Pelanggan tidak menerima barang yang dipesan di Toko Online
                  yang disebabkan kendala atau kesalahan Pihak Ketiga Penyedia
                  Layanan;
                </p>
              </li>
              <li>
                <p>
                  Kebijakan pengembalian atau penukaran barang antara Toko
                  Online dan pelanggan.
                </p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Gass.co.id selalu berupaya untuk menjaga Layanan Gass.co.id agar
              aman, nyaman, dan berfungsi dengan baik, tapi kami tidak dapat
              menjamin bahwa operasional atau akses ke Layanan Kami dapat selalu
              sempurna secara terus menerus. Informasi dan data dalam Situs
              memiliki kemungkinan tidak terjadi secara <em>real time</em>.
            </p>
          </li>
          <li>
            <p>
              Kami menyediakan Layanan dalam kondisi <b>“sebagaimana adanya”</b>
              . Anda memahami bahwa Kami tidak membuat pernyataan atau jaminan
              dalam bentuk apa pun yang menyatakan atau menjamin bahwa:
            </p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <p>
                  Penggunaan Layanan Kami akan selalu tepat waktu, bekerja
                  tanpa gangguan, atau bebas dari perubahan, penambahan,
                  pengurangan, transmisi, kerusakan, kerugian, pengalihan,
                  penyembunyian yang disebabkan oleh tindakan salah satu pihak
                  dengan sengaja dan tanpa hak atau melawan hukum;
                </p>
              </li>
              <li>
                <p>
                  Layanan Kami dapat terus beroperasi dan digunakan bersama
                  dengan perangkat atau sistem pihak lain yang tidak
                  disediakan atau dimiliki oleh Kami; dan/atau
                </p>
              </li>
              <li>
                <p>Layanan Kami akan selalu memenuhi ekspektasi Anda.</p>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Anda memahami bahwa Layanan Kami dapat mengalami gangguan atau
              penundaan karena tidak tersedianya atau gangguan layanan pihak
              ketiga yang Anda gunakan atau karena gangguan, ketidaktersediaan,
              atau malfungsi fitur tertentu pada perangkat yang Anda gunakan.
              Anda setuju untuk membebaskan Kami dari semua klaim, tuntutan,
              atau gugatan hukum sehubungan dengan kegagalan untuk melaksanakan
              instruksi Anda karena pengiriman informasi Anda yang tidak lengkap
              atau pembatalan atau perubahan instruksi yang dikirimkan kepada
              Kami kecuali jika disebabkan oleh kesalahan Kami yang disengaja.
            </p>
          </li>
          <li>
            <p>
              Anda setuju untuk membebaskan Kami dari segala klaim, tuntutan,
              atau gugatan hukum atas segala akibat atau kerugian yang timbul
              sehubungan dengan: (i) tidak terselesaikan atau tertundanya
              transaksi; dan/atau (ii) setiap gangguan, penundaan, perubahan,
              atau tidak tersedianya Gass.co.id atau Layanan Kami (termasuk jika
              kami tidak dapat melaksanakan atau melanjutkan sebagian atau
              seluruh instruksi atau komunikasi Anda kepada Kami melalui Situs
              atau Aplikasi), yang disebabkan oleh peristiwa atau hal-hal di
              luar kendali Kami, termasuk namun tidak terbatas pada Keadaan
              Kahar (sebagaimana didefinisikan di bawah), kegagalan sistem
              perbankan, krisis moneter, peretasan (hacking), perubahan/
              penambahan/pengurangan transmisi, kerusakan/ kerugian/ pengalihan,
              penyembunyian dalam sistem Peralatan kami atau layanan, yang
              disebabkan oleh tindakan suatu pihak ketiga yang dengan sengaja
              dan tanpa hak atau melawan hukum, gangguan atau tidak tersedianya
              layanan pihak ketiga, termasuk terganggunya jaringan internet,
              daya, telekomunikasi dan listrik secara terus menerus, atau hal
              lain di luar kendali Kami.
            </p>
          </li>
          <li>
            <p>
              Anda setuju bahwa Kami tidak bertanggung jawab atas segala akibat
              atau kerugian yang timbul dari hal-hal sebagaimana disebutkan di
              atas, termasuk namun tidak terbatas pada: (i) kehilangan data;
              (ii) hilangnya pendapatan, keuntungan, atau pendapatan lain;
              dan/atau (iii) kerugian, kerusakan, atau cedera yang timbul dari
              penggunaan Layanan Gass.co.id oleh Anda. Dalam hal apapun, jika
              Undang-Undang dan/atau badan hukum menyatakan bahwa Gass.co.id
              akan mengganti kerugian pengguna, tanggung jawab maksimum yang
              dapat ditanggung oleh Gass.co.id hanya terbatas pada jumlah
              transaksi yang relevan.
            </p>
          </li>
          <li>
            <p>
              Anda setuju untuk melepaskan Kami dari semua klaim, tuntutan,
              gugatan hukum, dan kompensasi apa pun dan dari pihak mana pun yang
              muncul sehubungan dengan:
            </p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                Penggunaan informasi atau data pribadi oleh Kami berdasarkan
                S&amp;K ini dan/atau Kebijakan Privasi Gass.co.id App, atau
                berdasarkan persetujuan, pengakuan, wewenang, kekuasaan
                dan/atau hak yang telah Anda berikan kepada Kami;
              </li>
              <li>
                Pemberian informasi atau data pribadi oleh Anda kepada Kami
                yang melanggar hukum atau peraturan yang berlaku, melanggar
                hak (termasuk Hak Kekayaan Intelektual) pihak lain, atau
                melanggar kontrak, perjanjian, pernyataan, keputusan, atau
                dokumen di mana Anda sebagai pihak atau terikat di dalamnya;
              </li>
              <li>
                Penggunaan Layanan Gass.co.id yang tidak sah, melanggar hukum
                dan ketentuan hukum yang berlaku, hak (termasuk Hak Kekayaan
                Intelektual) pihak lain, atau melanggar kontrak, perjanjian,
                pernyataan, keputusan, atau dokumen apa pun di mana Anda
                sebagai pihak atau terikat olehnya, atau melanggar S&amp;K ini.
              </li>
              <li>
                Sengketa, klaim, tindakan kepailitan, keterlambatan kewajiban
                hutang, investigasi, kejahatan, atau pelanggaran hukum,
                kekayaan intelektual atau peraturan lainnya dan ketentuan
                perundang-undangan yang terjadi, dieksekusi atau melibatkan
                Pengguna.
              </li>
              <li>
                Transaksi antara Pengguna dan pembeli atau Penggunaan Barang
                lebih lanjut kepada pihak lain, penggunaan atau pengalihan
                atau jaminan barang, keanggotaan, kerahasiaan, penyalahgunaan,
                penggunaan dan akses ke Aplikasi, Layanan, Konten, termasuk
                bagian dan informasi yang tersedia di dalamnya atau terkait
                dengan Akun, kata sandi, privasi, kerahasiaan Pengguna atau
                pembeli.
              </li>
            </ol>
          </li>
          <li>
            <p>
              Pengguna harus bertanggung jawab, membela, membebaskan dari segala
              tuntutan/klaim/gugatan, serta setuju untuk memberikan kompensasi
              kepada Gass.co.id (termasuk kepada pihak yang terkait/terafiliasi
              dengan Gass.co.id) atas seluruh kerugian baik langsung maupun
              tidak langsung yang diderita oleh Gass.co.id karena atau dalam
              kaitannya dengan hal-hal di atas dan masalah terkait karena
              kesalahan, kelalaian atau hal lain dari Pengguna atau Pembeli
              dan/atau pejabat, direksi, komisaris, karyawan, subkontraktor,
              pemasok, agen, dan perwakilan dari Pengguna dan/atau Pembeli.
            </p>
          </li>
        </ol>
      </section>

      <section>
        <h2>17. Kompensasi</h2>
        <article>
          <p>
            Anda setuju untuk membela, membebaskan, memberi kompensasi, dan
            melindungi Gass.co.id dan afiliasinya dari dan terhadap semua
            kewajiban, kerusakan, kerugian, dan pengeluaran apa pun (termasuk
            biaya dan biaya hukum yang wajar) yang berkaitan dengan, yang timbul
            dari, atau dengan cara apa pun sehubungan dengan salah satu dari
            berikut ini: (i) akses Anda ke atau penggunaan Layanan Kami,
            termasuk informasi yang diberikan sehubungan dengan itu; (ii)
            pelanggaran Anda atau dugaan pelanggaran S&amp;K ini; atau (iii)
            pernyataan Anda yang salah/ tidak akurat. Anda akan bekerja sama
            sepenuhnya seperti yang Kami minta dalam pembelaan atau penyelesaian
            klaim apa pun.
          </p>
        </article>
      </section>

      <section>
        <h2>18. Pembatalan dan Pengakhiran Layanan</h2>
        <article>
          <p>
            Anda dapat membatalkan Akun Anda atau mengakhiri perjanjian
            Ketentuan Layanan ini (<b>“Pengakhiran Layanan”</b>) kapanpun dengan
            menghubungi Gass.co.id Support di{" "}
            <a href="mailto:cs@gass.co.id">cs@gass.co.id</a> dan mengikuti
            instruksi khusus yang diberikan kepada Anda di email balasan dari
            Kami.
          </p>
        </article>

        <article>
          <p>
            Segera setelah Pengakhiran Layanan, baik oleh pihak Gass.co.id
            maupun oleh Anda untuk alasan apapun:
          </p>
          <ul>
            <li>
              Gass.co.id akan menghentikan penyediaan Layanan bagi Anda dan
              Anda tidak dapat lagi mengakses Akun Anda;
            </li>
            <li>
              Kecuali secara tegas dinyatakan lain dalam Ketentuan Layanan,
              Anda tidak berhak atas pengembalian biaya apapun, baik secara
              pro-rata maupun cara lainnya;
            </li>
            <li>
              Semua jumlah yang masih harus dibayar kepada Gass.co.id terkait
              penggunaan Layanan, pada saat efektif Pengakhiran Layanan akan
              segera jatuh tempo dan harus dibayar; dan
            </li>
            <li>
              Toko online Anda akan dijadikan <em>offline</em>.
            </li>
          </ul>
        </article>

        <article>
          <p>
            Apabila pada saat Pengakhiran Layanan, masih ada biaya terutang oleh
            Anda, Anda akan menerima tagihan akhir melalui email. Ketika tagihan
            tersebut dibayar penuh, Anda tidak akan ditagih lagi.
          </p>
        </article>

        <article>
          <p>
            Kami berhak memodifikasi atau menghentikan Layanan Gass.co.id,
            Ketentuan Layanan dan/atau Akun Anda untuk alasan apapun, dengan
            pemberitahuan tertulis kemudian. Pengakhiran Ketentuan Layanan tidak
            mengesampingkan hak atau kewajiban yang timbul sebelum tanggal
            pengakhiran.
          </p>
        </article>
      </section>

      <section>
        <h2>19. Kerjasama dengan Layanan Pihak Ketiga</h2>
        <ol>
          <li>
            Untuk mendukung dan melengkapi Layanan Gass.co.id serta memudahkan
            bisnis Anda, maka dari waktu ke waktu Gass.co.id memfasilitasi Anda
            untuk menggunakan layanan dari jasa pihak ketiga (
            <b>“Layanan Pihak Ketiga”</b>), termasuk namun tidak terbatas pada,
            layanan sistem pembayaran, layanan sistem pengiriman untuk transaksi
            antara Toko Online dan Pelanggan, dan layanan kebutuhan lainnya.
            Layanan Pihak Ketiga tersebut disediakan semata-mata hanya untuk
            kemudahan Anda, karenanya setiap pembelian, akses, atau penggunaan
            Anda atas Layanan Pihak Ketiga tersebut sepenuhnya hanya antara Anda
            dan pihak ketiga sebagai penyedia layanan.
          </li>
          <li>
            Dengan menggunakan Layanan Gass.co.id, Anda menyatakan setuju untuk
            menggunakan Layanan Pihak Ketiga. Anda menyatakan bahwa Anda
            memberikan persetujuan kepada Gass.co.id untuk memberikan data Anda
            untuk keperluan Layanan Pihak Ketiga tersebut, dengan memperhatikan
            Kebijakan Privasi Gass.co.id dan peraturan perundang-undangan yang
            berlaku.
          </li>
          <li>
            Anda memahami dan menerima bahwa penggunaan Layanan Pihak Ketiga
            oleh Anda menimbulkan hubungan hukum antara Anda dan Pihak Ketiga
            Penyedia Layanan. Anda setuju untuk terikat pada syarat dan
            ketentuan dari pihak ketiga sebagai penyedia layanan, termasuk
            kebijakan privasi mereka masing-masing, yang mana jika berbeda
            dengan S&amp;K ini dan/atau Kebijakan Privasi Gass.co.id, juga berlaku
            atas penggunaan Layanan Pihak Ketiga tersebut oleh Anda.
          </li>
        </ol>
      </section>

      <section>
        <h2>20. Layanan Gass.co.id Market</h2>
        <article>
          <p>
            Gass.co.id menyediakan Layanan Gass.co.id Market yang merupakan
            payung umum untuk Gass.co.id dan layanan lainnya, termasuk namun
            tidak terbatas pada Gass.co.id Page, Gass.co.id Store, Gass.co.id
            Menu, dan Gass.co.id Omni. Jika Anda menggunakan layanan yang
            disediakan oleh Layanan Gass.co.id Market, Anda menyetujui S&amp;K ini
            serta syarat dan ketentuan layanan serta kebijakan privasi dan
            kebijakan terkait lainnya yang berlaku pada partner dari Layanan
            Gass.co.id Market.
          </p>
          <p>
            Anda setuju untuk menggunakan Layanan Gass.co.id Market sesuai
            dengan: (i) Dokumentasi teknis dan produk kami, dan dokumentasi
            terkait lainnya yang disediakan oleh Gass.co.id dan afiliasinya
            (secara kolektif disebut “Dokumentasi” ); dan (ii) Kebijakan Layanan
            Gass.co.id Market.
          </p>
          <p>
            <b>Pembatasan</b>. Sehubungan dengan data yang Anda peroleh dari
            penggunaan Layanan Gass.co.id Market, Anda tidak boleh secara
            langsung maupun tidak langsung (i) membagikan, mentransfer/
            memindahkan, menjual, melisensikan, atau mendistribusikan data apa
            pun, termasuk dalam bentuk anonim, agregat, atau turunan dari data
            tersebut kepada pihak ketiga manapun; atau (ii) melakukan penargetan
            ulang pada atau di luar layanan Gass.co.id, menggunakan tumpangan
            atau pengalihan, atau menggabungkan data tersebut dengan sumber data
            pihak ketiga lainnya. Kami dapat menghentikan akun Anda dan segera
            mencabut akses Anda jika Kami beranggapan bahwa Anda telah melanggar
            batasan ini. Ketentuan ini akan tetap berlaku meskipun Persyaratan
            Gass.co.id Market yang diatur di Pasal ini berakhir.
          </p>
          <p>
            Pelaporan. Dari waktu ke waktu, Kami dapat meminta Anda untuk
            memberikan kami laporan terkait penggunaan Anda atas Layanan
            Gass.co.id Market, dan Anda setuju untuk memberikannya kepada Kami
            tidak lebih dari 30 hari setelah tanggal permintaan Kami.
          </p>
          <p>
            Anda mengetahui bahwa Layanan Gass.co.id Market merupakan layanan
            penyediaan tools dan extensions yang tersedia untuk Layanan
            Gass.co.id yang merupakan produk layanan partner yang terafiliasi
            dengan Gass.co.id. Dengan menggunakan Layanan Gass.co.id, Anda
            menyatakan bahwa Anda memberikan persetujuan kepada Gass.co.id untuk
            memberikan data Anda kepada partner yang terafiliasi dengan
            Gass.co.id untuk keperluan Layanan Gass.co.id Market tersebut,
            dengan memperhatikan Kebijakan Layanan Gass.co.id Market, Kebijakan
            Privasi Gass.co.id, Kebijakan Layanan dan Kebijakan Privasi milik
            partner serta peraturan perundang-undangan yang berlaku.
          </p>
          <p>
            Gass.co.id dapat memperbarui Kebijakan Layanan Gass.co.id Market ini
            ( “Modifikasi” ) dengan memberikan pemberitahuan 14 hari kerja
            sebelumnya sebelum ada Modifikasi. Dengan terus menggunakan Layanan
            Gass.co.id Market setelah Modifikasi, Anda menyetujui Modifikasi
            tersebut. Kami berhak memodifikasi atau menghentikan Layanan
            Gass.co.id Market, Ketentuan Layanan dan/atau Akun Anda untuk alasan
            apapun, dengan pemberitahuan tertulis setelahnya. Pengakhiran
            Ketentuan Layanan tidak mengesampingkan hak atau kewajiban yang
            timbul sebelum tanggal pengakhiran.
          </p>
        </article>
      </section>

      <section>
        <h2>21. Layanan Gass.co.id Wholesale</h2>
        <article>
          <p>
            Anda mengetahui bahwa Layanan Gass.co.id Wholesale merupakan
            platform jual beli grosir online untuk Supplier dan Retailer. Untuk
            menghindari keraguan atas tanggung jawab Gass.co.id dalam penyediaan
            Layanan Gass.co.id Wholesale, terdapat ketentuan sebagai berikut:
          </p>
        </article>

        <ol>
          <li>
            <p>
              Untuk proses registrasi Layanan Gass.co.id Wholesale, dilakukan
              dengan cara sebagai berikut:
            </p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                <em>Supplier</em> tidak dapat melakukan registrasi
                mandiri/self-registration, dapat dibantu oleh tim dari
                Gass.co.id melalui{" "}
                <a href="https://gass.co.id/" target="_blank" rel="noopener noreferrer">
                  https://gass.co.id/
                </a>
              </li>
              <li>
                Retailer dapat melakukan registrasi langsung pada platform
                Layanan Gass.co.id Wholesale melalui{" "}
                <a href="https://gass.co.id/" target="_blank" rel="noopener noreferrer">
                  https://gass.co.id/
                </a>
              </li>
            </ol>
          </li>
          <li>
            <p>
              Untuk pengiriman barang oleh Supplier kepada Retailer, dapat
              dilakukan dengan dua metode pengiriman, yakni:
            </p>
            <ol style={{ listStyleType: "lower-alpha" }}>
              <li>
                Menggunakan kurir yang ditunjuk oleh Supplier yang diatur
                sendiri metode pengirimannya di luar Layanan Gass.co.id dan
                ditentukan sendiri untuk biaya pengirimannya.
              </li>
              <li>
                <em>Supplier</em> dapat memilih layanan pengiriman yang
                disediakan oleh perusahaan layanan logistik yang bekerja sama
                dengan Gass.co.id.
              </li>
            </ol>
          </li>
          <li>
            Dengan mengacu pada ketentuan di bagian di atas, pengiriman akan
            dilakukan oleh perusahaan penyedia jasa kurir/pengiriman yang
            ditunjuk oleh masing-masing Supplier, dan bukan oleh Gass.co.id.
            Gass.co.id bertanggung jawab untuk memfasilitasi laporan/keluhan
            dari Retailer apabila Retailer belum menerima produk dalam jangka
            waktu yang diestimasikan. Dalam hal Retailer belum menerima produk
            dalam jangka waktu yang diestimasikan, maka Retailer harus
            memberitahu kepada Gass.co.id melalui cs@Gass.co.id.app. Gass.co.id
            selanjutnya akan meneruskan laporan Retailer kepada Supplier
            dan/atau penyedia jasa kurir/pengiriman yang bersangkutan untuk
            memberikan solusi yang terbaik bagi Supplier dan Retailer.
          </li>
          <li>
            Tanggung jawab Gass.co.id terbatas pada layanan Gass.co.id melalui
            layanan keluhan pelanggan (customer service) untuk memfasilitasi
            laporan/keluhan Retailer kepada Supplier dan/atau perusahaan
            penyedia jasa kurir/pengiriman yang bersangkutan. Pengguna memahami
            dan setuju bahwa tanggung jawab Gass.co.id adalah sebatas yang telah
            disebutkan di atas dan Gass.co.id tidak akan bertanggung jawab atas
            kerusakan, pengeluaran, biaya atau ongkos yang timbul dari resiko
            pengiriman barang dan Supplier dan/atau Retailer akan membicarakan
            hal tersebut dengan penyedia jasa logistik untuk menyelesaikan
            permasalahan tersebut.
          </li>
          <li>
            Supplier atau Retailer hanya dapat membatalkan transaksi atau
            pesanannnya sebelum barang dikirim. Gass.co.id akan memvalidasi
            kepada pihak Supplier dan Retailer sebelum melakukan pencairan uang.
          </li>
          <li>
            Apabila Retailer ingin mengajukan pengembalian barang, saat ini
            Retailer harus menghubungi Supplier secara langsung untuk melakukan
            proses pengajuan tersebut di luar Layanan Gass.co.id Wholesale.
          </li>
          <li>
            Dalam kondisi Retailer mengajukan pengembalian dana akibat kerusakan
            atau kecacatan barang atau kondisi terkait lainnya, Retailer dapat
            menghubungi customer service Gass.co.id untuk dibantu prosesnya
            kepada Supplier.
          </li>
        </ol>
      </section>

      <section>
        <h2>22. Deklarasi dan Garansi</h2>
        <article>
          <p>Anda dengan ini menyatakan dan menjamin yang berikut:</p>
          <ol>
            <li>
              Otoritas dan Penerapan. Anda telah memperoleh persetujuan
              perusahaan (<em>corporate approval</em>) dan segala persetujuan
              lain yang diperlukan, sehingga Anda memiliki kewenangan penuh
              untuk tunduk dan terikat pada serta untuk melakukan dan
              melaksanakan seluruh kewajiban Anda berdasarkan S&amp;K ini.
            </li>
            <li>
              Izin. Anda telah memperoleh izin, lisensi, dan kewenangan yang
              serupa untuk menjalankan kegiatan bisnis seperti yang sedang
              atau akan dilakukan saat ini dan izin, lisensi, atau kewenangan
              serupa tersebut adalah sah, mengikat, berlaku penuh dan akan
              terus berlaku selama pelaksanaan bisnis Anda dan penggunaan
              Layanan Gass.co.id untuk bisnis Anda.
            </li>
            <li>
              Kepatuhan terhadap Hukum yang Berlaku. Anda telah mematuhi dan
              tidak melanggar ketentuan hukum apa pun yang terkait dengan
              kegiatan bisnis, operasional, aset, atau properti yang
              seharusnya mengikat Anda atau bisnis Anda. Tidak ada peristiwa
              atau situasi yang (dengan atau tanpa berlalunya waktu atau
              dengan pemberitahuan) dapat mengakibatkan pelanggaran atau
              konflik, atau kegagalan Anda, untuk mematuhi hukum dan
              peraturan.
            </li>
            <li>
              Anti Pencucian Uang dan Pencegahan Pendanaan Terorisme. Anda
              menyatakan dan menjamin bahwa: Anda mengetahui dan memahami
              semua Undang-Undang dan peraturan Anti Pencucian Uang dan
              Pencegahan Pendanaan Terorisme yang berlaku dari waktu ke waktu
              untuk setiap transaksi bisnis dan aktivitas yang dilakukan
              sehubungan dengan S&amp;K ini, dan tidak akan mengambil tindakan apa
              pun yang melanggar atau mungkin melanggar Undang-Undang dan
              peraturan Anti Pencucian Uang dan Pencegahan Pendanaan
              Terorisme.
            </li>
            <li>
              Anti-korupsi. Anda menyatakan dan menjamin bahwa: Anda
              mengetahui dan memahami semua Undang-Undang dan peraturan
              anti-korupsi yang berlaku dari waktu ke waktu untuk setiap
              transaksi bisnis dan aktivitas yang dilakukan sehubungan dengan
              S&amp;K ini, dan tidak akan mengambil tindakan apa pun yang
              melanggar atau mungkin melanggar Undang-Undang dan peraturan
              antikorupsi.
            </li>
          </ol>
        </article>
        <article>
          <p>
            Anda mengetahui dan memahami semua peraturan perundang-undangan dan
            peraturan pelaksana yang dikeluarkan oleh (namun tidak terbatas
            pada) Pemerintah Republik Indonesia, Bank Indonesia, Otoritas Jasa
            Keuangan dan Badan Pengawas lainnya terkait anti pencucian uang dan
            pencegahan pendanaan terorisme. Tujuan penggunaan Layanan Gass.co.id
            ini dan segala transaksi serta aktivitas bisnis yang dilakukan
            sehubungan dengan S&amp;K tidak melanggar peraturan perundang-undangan
            dan peraturan pelaksanaan mengenai anti suap, anti korupsi, anti
            pencucian uang dan pencegahan terorisme. Anda harus memenuhi, dan
            memastikan bahwa setiap pimpinan, pemilik, pemegang saham, pejabat,
            direktur, karyawan, dan/atau agen Anda mematuhi semua undang-undang
            dan peraturan serta peraturan pelaksana tentang anti penyuapan, anti
            korupsi, anti pencucian uang dan pencegahan pendanaan terorisme
            dalam setiap transaksi bisnis dan aktivitas yang dilakukan
            sehubungan dengan S&amp;K ini.
          </p>
        </article>
        <article>
          <p>
            Anda akan mengusahakan dan mewajibkan pejabat, direktur, direksi,
            karyawan, dan agen Anda untuk menjaga reputasi baik Gass.co.id dalam
            menggunakan Layanan Gass.co.id sebagaimana dimaksud dalam S&amp;K dengan
            jujur, itikad baik, serta mematuhi kebijakan, pedoman, standar
            etika, dan peraturan yang berlaku.
          </p>
        </article>
        <article>
          <p>
            Dengan ini Anda menyatakan, menjamin, dan berjanji kepada Gass.co.id
            bahwa:
          </p>
          <ul>
            <li>
              Anda adalah pemilik tunggal yang tidak dibebani dan, jika
              terdaftar, satu-satunya pemilik terdaftar dari semua hak
              kekayaan intelektual yang digunakan dalam bisnis Anda, termasuk
              Logo dan/atau Merek Dagang, seluruhnya adalah milik Anda dan
              didistribusikan secara legal.
            </li>
            <li>
              Hak Kekayaan intelektual Anda dan validitas atau keberadaan hak,
              hak milik, dan kepentingan Anda di dalamnya bukanlah subjek dari
              sengketa, klaim, atau proses hukum yang berlaku saat ini, yang
              ditangguhkan atau dapat dikenakan, termasuk pada upaya untuk
              menentang, membatalkan, menarik atau memperbaiki pendaftaran
              atas Hak Kekayaan Intelektual Anda, dan Hak Kekayaan Intelektual
              Anda tidak pernah menjadi subjek sengketa, klaim atau proses
              hukum, dan tidak ada fakta atau hal yang dapat menimbulkan
              sengketa, klaim atau proses hukum tersebut.
            </li>
            <li>
              Anda telah mengambil semua langkah yang diperlukan untuk
              melindungi Hak Kekayaan Intelektual Anda. Tanpa batasan, semua
              biaya pembaruan yang berkaitan dengan Hak Kekayaan Intelektual
              Anda yang jatuh tempo, telah dibayar penuh.
            </li>
            <li>
              Anda tidak terlibat dalam aktivitas apa pun yang melanggar Hak
              Kekayaan Intelektual milik pihak ketiga mana pun. Tidak ada Hak
              Kekayaan Intelektual Anda yang saat ini dilanggar oleh pihak
              ketiga mana pun atau telah dilanggar dan tidak ada pihak ketiga
              yang mengancam untuk melakukan pelanggaran semacam itu.
            </li>
          </ul>
        </article>
      </section>

      <section>
        <h2>23. Keadaan Kahar</h2>
        <article>
          <p>
            Setiap Pihak akan dibebaskan dari pelaksanaan kewajibannya
            berdasarkan Perjanjian apabila pelaksanaan kewajiban tersebut
            terhambat atau tidak dapat dilakukan karena suatu Keadaan
            Kahar/Force Majeure (didefinisikan di bawah) dan Pihak yang tidak
            dapat melaksanakan kewajibannya tersebut harus segera memberikan
            pemberitahuan atas ketidakmampuannya tersebut kepada Pihak lainnya.
            Pihak yang terkena Keadaan Kahar juga harus memberi tahu Pihak
            lainnya tentang durasi Keadaan kahar yang diantisipasi
            selambat-lambatnya 30 (tiga puluh) hari setelah terjadinya Keadaan
            Kahar. Pihak yang terdampak Keadaan Kahar tersebut juga harus
            memberitahukan kepada Pihak lainnya setiap tindakan yang diambil
            untuk menghindari atau meminimalkan efek Keadaan Kahar setelah
            kejadian dan harus melakukan upaya yang wajar untuk menghilangkan
            kondisi yang merupakan Keadaan Kahar tersebut. Untuk tujuan
            Perjanjian ini, “Keadaan Kahar”merupakan mencakup kondisi/ peristiwa
            yang terjadi di luar kendali Para Pihak, termasuk bencana alam (Act
            of God), tindakan terorisme, kepatuhan sukarela atau tidak sukarela
            terhadap peraturan pemerintah/undang-undang/ kebijakan pemerintah,
            perang (baik perang diumumkan atau tidak), pemogokan tenaga kerja,
            kerusuhan sipil, epidemi, pandemi, kegagalan atau kerusakan
            fasilitas umum atau transportasi umum, hancurnya fasilitas atau
            bahan produksi karena kebakaran, gempa bumi, badai atau bencana
            serupa. Pembayaran invoice yang sudah jatuh tempo dan terutang
            disini tetap menjadi kewajiban dan tidak akan ditunda oleh pihak
            yang harus membayarkan.
          </p>
        </article>
      </section>

      <section>
        <h2>24. Hukum yang Berlaku</h2>
        <article>
          <p>
            Hak dan kewajiban para pihak sesuai dengan S&amp;K ini diatur tunduk dan
            ditafsirkan sesuai dengan hukum yang berlaku di wilayah Negara
            Republik Indonesia. Dengan ini, Anda menyatakan bahwa Anda tunduk
            pada yurisdiksi eksklusif Pengadilan Negeri Jakarta Selatan untuk
            setiap perselisihan yang timbul karena atau sehubungan dengan S&amp;K
            ini, dan dengan ini Anda melepaskan hak Anda untuk melakukan proses
            hukum di yurisdiksi lain mana pun. Kami berhak untuk menjalankan
            proses hukum sehubungan dengan masalah apa pun yang timbul
            berdasarkan S&amp;K ini di yurisdiksi mana pun tempat Anda tinggal,
            berbisnis, atau memiliki aset.
          </p>
        </article>
      </section>

      <section>
        <h2>25. Bahasa</h2>
        <article>
          <p>
            Untuk memenuhi ketentuan Undang-Undang Republik Indonesia No. 24
            tahun 2009 tanggal 9 Juli 2009 tentang Bendera, Bahasa, Lambang dan
            Lagu Kebangsaan (<b>“UU No. 24”</b>), maka S&amp;K ini dibuat dalam
            Bahasa Inggris dan Bahasa Indonesia. Jika terdapat ketidaksesuaian
            atau perbedaan interpretasi antara teks Bahasa Inggris dan teks
            Bahasa Indonesia, Gass.co.id dan Anda dengan ini setuju bahwa teks
            Bahasa Indonesia yang akan berlaku. Gass.co.id dan Anda selanjutnya
            setuju bahwa tidak ada Pihak yang dengan cara atau forum apa pun,
            atau dalam yurisdiksi mana pun, akan menantang keabsahan, atau
            mengajukan keberatan apa pun terhadap S&amp;K ini atas dasar
            ketidakpatuhan terhadap UU No.24.
          </p>
        </article>
      </section>

      <section>
        <h2>26. Keterpisahan</h2>
        <article>
          <p>
            Apabila terdapat ketentuan dalam S&amp;K ini yang karena suatu alasan
            apapun menjadi tidak berlaku, tidak sah atau tidak dapat
            diberlakukan dalam segala hal, maka ketidakberlakuan, ketidakabsahan
            atau tidak dapat diberlakukan tersebut tidak berpengaruh pada
            ketentuan lain dalam Syarat atau Ketentuan ini. Sehubungan dengan
            hal tersebut, ketentuan tersebut harus diinterpretasikan dan
            ditafsirkan seakan-akan ketentuan tersebut, sejauh tidak dapat
            diberlakukan, tidak pernah ada dalam S&amp;K ini. Gass.co.id berhak
            mengubah dan/atau menggantikan ketentuan yang dibatalkan dengan
            ketentuan lain sepanjang diizinkan oleh hukum dan peraturan
            perundang-undangan yang berlaku dengan pemberitahuan 14 hari kerja
            sebelumnya.
          </p>
        </article>
      </section>

      <section>
        <h2>27. Kontak dan Pemberitahuan</h2>
        <ol>
          <li>
            Setiap pemberitahuan dari Kami yang ditujukan kepada Anda atau
            Pengguna akan diumumkan melalui Situs dan dikirim melalui surat
            elektronik (email) atau layanan pesan instan kepada Pengguna yang
            terdaftar di Akun Gass.co.id atau Kami.
          </li>
          <li>
            Setiap pemberitahuan dari Anda atau Pengguna yang ditujukan kepada
            Kami menjadi efektif ketika pemberitahuan tersebut diterima oleh
            Kami melalui alamat surat elektronik{" "}
            <a href="mailto:cs@gass.co.id">cs@gass.co.id</a>.
          </li>
        </ol>
      </section>

      <section>
        <h2>28. Lainnya</h2>
        <article>
          <p>
            Gass.co.id memiliki kewenangan mutlak untuk merevisi, mengubah,
            dan/atau menambahkan ketentuan pada S&amp;K ini dengan pemberitahuan 14
            hari sebelumnya sebelum ada revisi terhadap S&amp;K ini, sebagai bentuk
            permintaan persetujuan Anda melalui pengumuman atau tautan
            elektronik. Penggunaan Layanan berkelanjutan oleh Anda setelah
            menerima pemberitahuan akan perubahan tersebut juga dapat dianggap
            sebagai penerimaan Anda terhadap S&amp;K yang telah direvisi tersebut.
          </p>
        </article>
      </section>

      <p>Pembaruan terakhir: 30/10/2023</p>
    </LegalShell>
  );
}
